import React from 'react';
import { Link } from 'react-router-dom';
import NavBar from './NavBar';
import SideBar from './SideBar';
import './Menu.css';

function Menu() {
    return (
        <div className="menu-shell">
            <NavBar />
            <div className="menu-logo-slot">
                <Link to="/dashboard" className="flex items-center no-underline">
                    <img src="/img/logo.png" alt="NeuraTrader" />
                </Link>
            </div>
            <SideBar />
        </div>
    );
}

export default Menu;
